import { Text } from '@axo/ui-core/components/typography';
import styles from '../expenses.module.scss';
import { useTranslation } from '@axo/shared/i18n';
import { useFormContext } from 'react-hook-form';
import {
  allExpensesOptions,
  AllExpensesOptions,
} from '../config/allExpensesOptions';
import { getExpenses } from '../../../../../../utils/Denmark/calculateExpenses';

export const PreviewExpenses = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const categories: (keyof AllExpensesOptions)[] = [
    'electricity',
    'water',
    'heating',
    'insurance',
  ];

  const watchedValues = watch([
    'Expense/Electricity/Value',
    'Expense/Water/Value',
    'Expense/Heating/Value',
    'Expense/Insurance/Value',
  ]);

  const finalExpenses = getExpenses({
    categories: categories,
    values: watchedValues,
    options: allExpensesOptions,
    t,
  });

  return (
    <ul className={styles.list}>
      {finalExpenses.map(({ label, value }) => {
        return (
          <li key={label}>
            <Text size="m">
              <b>{label}</b>
            </Text>
            <Text size="m">{value}</Text>
          </li>
        );
      })}
    </ul>
  );
};
